import { useState } from 'react'
import { Trans } from '@lingui/macro'

import { Alert, Box, Button, CircularProgress, Stack } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

import { useIsDcParameterRegisteredQuery } from '@/core/services/dmp-connect-js2'

import { DownloadButtons } from './DownloadButtons'
import { LocalNetworkAccessDialog } from './LocalNetworkAccessDialog'

export function CheckDMPConnect() {
  const [showLocalNetworkDialog, setShowLocalNetworkDialog] = useState(true)
  useIsDcParameterRegisteredQuery('', { pollingInterval: 5000 })

  return (
    <Box>
      <div className="relative">
        <Alert severity="info">
          <Trans>Waiting for connector installation</Trans>
        </Alert>
        <div className="absolute top-1/2 right-3 -translate-y-1/2 w-5 h-5">
          <CircularProgress size={20} />
        </div>
      </div>
      <p>
        <Trans>Please click the buttons below to download the app</Trans>
      </p>
      <DownloadButtons />
      <Box mt={2}>
        <Trans>
          If the connector has already been installed, please ensure that it is operational: see{' '}
          <a href="https://www.icanopee.fr/controle-du-connecteur-dmp/" target="_blank" rel="noopener noreferrer">
            DMP Connector Checking Operation
          </a>
        </Trans>
      </Box>
      <Box mt={2}>
        <Trans id="Si vous utilisez Chrome en version >= 142, il est nécessaire de donner accès au réseau local">If you use Chrome 142 or later, you must allow local network access</Trans>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Button variant="outlined" color="warning" size="small" startIcon={<HelpOutlineIcon />} onClick={() => setShowLocalNetworkDialog(true)}>
            <Trans id="Accès au réseau local">Local network access</Trans>
          </Button>
        </Stack>
        <LocalNetworkAccessDialog open={showLocalNetworkDialog} onClose={() => setShowLocalNetworkDialog(false)} />
      </Box>
    </Box>
  )
}
